import { openDB } from 'idb';

// console.clear();

const VERSION = 2;

export const database = await openDB('FastingFlux', VERSION, {
  async upgrade(db, oldVersion, _newVersion, transaction) {
    switch (oldVersion + 1) {
      case 1:
        await db.createObjectStore('key-val');
        await db.createObjectStore('sessions', {
          keyPath: 'id',
          autoIncrement: true,
        });

      case 2:
        await transaction
          .objectStore('sessions')
          .createIndex('startedAt', 'startedAt', { unique: false });

    }
  },
});

// console.log(database);
window.database = database;

